import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServerTenant = createAPI("multiTenant");

const reqEmpresaHorario = {
	list: async function (paramUrlComponent, paramValueUrlComponent, active, page) {
		return apiServerTenant
			.get("portal/v1/empresa-horario", {
				headers: { banco },
				params: {
					param: paramUrlComponent,
					paramValue: paramValueUrlComponent,
					active: active,
					page: page,
					perpage: 15,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},

	listID: async function (id) {
		return apiServerTenant
			.get(`portal/v1/empresa-horario/${id}`, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},

	insert: async function (data) {
		return apiServerTenant
			.post("portal/v1/empresa-horario", data, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},

	delete: async function (id) {
		return apiServerTenant
			.delete(`portal/v1/empresa-horario/${id}`, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresaHorario;
